import React from 'react';

const HeaderContext = React.createContext();

export default HeaderContext;
